module.exports = __webpack_public_path__ + "static/media/tela_emissao.89c40abc.svg";